import axios from 'axios';

import { PaginationHeaders } from '@pushspring/ps-common/lib/constants-public';

import { ConfigService } from '../../utils/ConfigService';

const clientConfig = new ConfigService();

export async function getAttributes() {
    try {
        // Server paginates this endpoint (large orgs can exceed API Gateway's response size
        // limit in one shot) - loop pages so callers still just get the full array back.
        // Server only sends NEXT_OFFSET when there's another page, so its presence alone
        // tells us whether to keep going.
        let allAttributes = [];
        let offset = 0;
        let nextOffset;
        do {
            const { data, headers } = await axios.get(clientConfig.eventotronPrefix + '/v1/marketplace/attribute', {
                params: { offset },
            });
            allAttributes = allAttributes.concat(data);
            nextOffset = Number(headers[PaginationHeaders.NEXT_OFFSET]);
            offset = nextOffset;
        } while (nextOffset > 0);
        return allAttributes;
    } catch (e) {
        throw new Error('There was an error getting the attributes.');
    }
}

export async function importTaxonomy(filePath) {
    try {
        const { data } = await axios.post('/api/attribute/import', { filePath: filePath });
        return data;
    } catch (e) {
        const errorMessage = e.response?.data;
        // Throw specific error messages related to file format from backend
        throw new Error(errorMessage);
    }
}

export async function create(attribute) {
    try {
        const { data } = await axios.post(clientConfig.eventotronPrefix + '/v1/marketplace/attribute', attribute);
        return data;
    } catch (e) {
        throw new Error('There was an error creating new attribute.');
    }
}

export async function update(attribute) {
    try {
        const attributeId = attribute.attribute_id;
        const { data } = await axios.patch(
            clientConfig.eventotronPrefix + '/v1/marketplace/attribute/' + attributeId,
            attribute,
        );
        return data;
    } catch (e) {
        throw new Error('There was an error updating the attribute.');
    }
}
